import React from 'react';
import { motion } from 'framer-motion';
import { useMetaPixel } from '../../hooks/useMetaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  isCheckout?: boolean;
  href?: string;
  className?: string;
}
export function Button({
  children,
  isCheckout,
  href,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const {
    trackCheckout
  } = useMetaPixel();
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    trackCheckout();
    if (onClick) {
      onClick(e);
    }
    if (href) {
      window.open(href, '_blank');
      return;
    }
    if (!isCheckout) {
      const checkoutSection = document.getElementById('checkout');
      if (checkoutSection) {
        checkoutSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`w-full md:w-auto px-5 py-3 md:px-8 md:py-4 bg-[#C8956C] hover:bg-[#A67754] text-white font-bold rounded-full shadow-lg transition-colors duration-300 text-sm md:text-lg flex items-center justify-center gap-2 ${className}`} {...props} data-id="element-209">
      {children}
    </motion.button>;
}